import { useDispatch, useSelector } from 'react-redux';
import { setMenuType } from '../reducers/app';

import IconArrowBack from './Icons/IconArrowBack';

import { MENU_KAUF, MENU_VERKAUF, PHASE2_KAUF_SP_AKTIV, PHASE2_VERKAUF_MIT_AKTIVITAET, PHASE3_VERKAUF, PHASE4_VERKAUF } from '../constants';
import { useHandleApp } from '../hooks/app/useHandleApp';
import { useHandleMenu } from '../hooks/menu/useHandleMenu';
import { useCallback } from 'react';

function StickyButtonDemo({ cssClasses = '' }) {
  const menuId = useSelector((state) => state.app.menuId);

  const { updateMenu } = useHandleMenu();
  const { undoDemo } = useHandleApp();

  const dispatch = useDispatch();

  // Memoize the demo phase setter to avoid recreating on each render
  const setDemoPhase = useCallback(
    (newphase) => {
      if (!newphase) return;

      updateMenu(newphase);

      if (newphase === PHASE2_VERKAUF_MIT_AKTIVITAET || newphase === PHASE3_VERKAUF || newphase === PHASE4_VERKAUF) {
        dispatch(setMenuType(MENU_VERKAUF));
      } else if (newphase === PHASE2_KAUF_SP_AKTIV) {
        dispatch(setMenuType(MENU_KAUF));
      }
    },
    [dispatch, updateMenu],
  );

  return (
    <>
      <div className="stickySidebar-wrapper">
        <div className={`stickySidebar__btn ${cssClasses}`} onClick={() => undoDemo()}>
          <IconArrowBack />
          <span>
            Demo <br />
            verlassen
          </span>
        </div>

        <div className="stickySidebar__panel">
          <span className={`${menuId === PHASE2_VERKAUF_MIT_AKTIVITAET ? 'active' : ''}`} onClick={() => setDemoPhase(PHASE2_VERKAUF_MIT_AKTIVITAET)}>
            Vermarktung
            <br />
            Verkäufer:in
          </span>
          <span className={`${menuId === PHASE3_VERKAUF ? 'active' : ''}`} onClick={() => setDemoPhase(PHASE3_VERKAUF)}>
            Verkauf
          </span>
          <span className={`${menuId === PHASE4_VERKAUF ? 'active' : ''}`} onClick={() => setDemoPhase(PHASE4_VERKAUF)}>
            Nach dem
            <br />
            Verkauf
          </span>
          <span className={`${menuId === PHASE2_KAUF_SP_AKTIV ? 'active' : ''}`} onClick={() => setDemoPhase(PHASE2_KAUF_SP_AKTIV)}>
            Dashboard
            <br />
            Käufer:in
          </span>
        </div>
      </div>
    </>
  );
}

export default StickyButtonDemo;
